import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { initializeWebPush, getWebPushParams } from '@ciceksepeti/cs-web-push';
import { setCookie } from '@ciceksepeti/cs-cookie';
import WebPush from '@constants/web-push';
import Services from '@constants/services';
import ScriptKeys from '@constants/script-keys';
import Cookies from '@constants/cookies';
import { getReferrer } from '@helpers/referrer';
import { useCommons } from '@hooks/use-commons';
var Content = function () {
    var _a;
    var pathname = useLocation().pathname;
    var variables = useCommons().variables;
    var settings = variables.settings;
    var webPushSetting = settings === null || settings === void 0 ? void 0 : settings.filter(function (setting) { return setting.key == ScriptKeys.WEB_PUSH; });
    var isWebPushEnabled = !!(webPushSetting && ((_a = webPushSetting[0]) === null || _a === void 0 ? void 0 : _a.value) == 'true');
    var handleNotificationPermission = useCallback(function () {
        initializeWebPush(Services.API_URL, isWebPushEnabled);
    }, [isWebPushEnabled]);
    useEffect(function () {
        var checkCount = 0;
        var brazeTimeoutId;
        var checkBrazeLoaded = function () {
            if (window.braze) {
                handleNotificationPermission();
                clearTimeout(brazeTimeoutId);
                return;
            }
            if (checkCount < WebPush.TIMEOUT_COUNT) {
                checkCount++;
                brazeTimeoutId = setTimeout(checkBrazeLoaded, 1000);
            }
        };
        checkBrazeLoaded();
    }, [handleNotificationPermission]);
    useEffect(function () {
        var actualReferrer = document.referrer;
        if (actualReferrer !== window.location.href) {
            setCookie(Cookies.REFERRER, actualReferrer, {
                path: '/'
            });
        }
    }, []);
    useEffect(function () {
        var page = pathname == '/hesabim/siparislerim' || pathname == '/hesabim/yarim-kalan-siparislerim'
            ? 'order-tracking'
            : 'other';
        getWebPushParams({ page: page });
        return function () {
            var referrer = getReferrer(pathname);
            setCookie(Cookies.REFERRER, referrer, {
                path: '/'
            });
        };
    }, [pathname]);
    return _jsx(Outlet, {});
};
export default Content;
